import React from "react";
import classNames from "classnames";
import { Icon } from "../..";
const MENU_ITEM = "at-menu-item";
export const MenuItem = (props) => {
  const { children, active, disabled, icon, className, text, onClick } = props;
  const hasSubmenu = !!children;
  const anchorClasses = classNames(
    MENU_ITEM,
    {
      [`${MENU_ITEM}--active`]: active,
      [`${MENU_ITEM}--disabled`]: disabled,
    },
    className
  );
  const target = (
    <button className={anchorClasses} onClick={(e) => !disabled && onClick && onClick(e)}>
      <Icon icon={icon}></Icon>
      <span>{text}</span>
    </button>
  );
  // const Popover =
  return <li>{!hasSubmenu && target}</li>;
};
